import React from 'react'
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from '../contexts/CustomContextHook/useAuth';

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (error) {
    return null;
  }
}



const AuthVerify = ({ history }) => {



  const { UserToken, setUserToken } = useAuth();

  const logout = () => {

    setUserToken('','', '', '', [], '', '','','');

  }

  // console.log('hisoty :: ', history);
  console.log('*************&&&&&&F$$$$');


  if (UserToken.token !== "") {
    const decodedJwt = parseJwt(UserToken.token);

    console.log((decodedJwt.exp * 1000) > Date.now());

    if (decodedJwt.exp * 1000 < Date.now()) {

      toast.error('Your session has expired. Please login again')

      logout()

      // console.log('decodedJwt ', decodedJwt.exp * 1000);
      // console.log('Date.now() ', Date.now());

    }

    return (
      <div></div>
    )
  }
}

export default withRouter(AuthVerify);